import { cx } from "@jugl-web/utils";
import { InputHTMLAttributes, forwardRef } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: "underline" | "outlined";
  isError?: boolean;
  maxLength?: number;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = "text",
      variant = "underline",
      className,
      isError,
      maxLength,
      ...props
    },
    ref
  ) => {
    const isOverMaxLength =
      maxLength && props.value && String(props.value).length > maxLength;
    const shouldShowCounter =
      maxLength && props.value && String(props.value).length > maxLength - 3;
    return (
      <>
        <input
          ref={ref}
          type={type}
          className={cx(
            "border-0 border-solid border-black/20 p-2.5 outline-none",
            "text-base leading-4 font-medium text-[#363636] transition-colors",
            "placeholder:font-normal placeholder:text-dark-500",
            "focus:border-primary-300",
            variant === "underline" ? "border-b" : "rounded-lg border",
            (isError || isOverMaxLength) &&
              "border-gradients-danger focus:border-gradients-danger",
            className
          )}
          {...props}
        />
        {(shouldShowCounter && (
          <div
            className={cx("mt-2 text-xs text-gradients-danger", {
              "text-gradients-danger": isOverMaxLength,
              "text-grey-A100": !isOverMaxLength,
            })}
          >{`${String(props.value).length || 0}/${maxLength}`}</div>
        )) ||
          ""}
      </>
    );
  }
);
